import React, { memo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSupplierInvoiceData } from '../../actions';
import { Table, Loading } from '../../../../../common/ui';

const columns = [
  { id: 'incrementId', label: 'ID', minWidth: 80 },
  {
    id: 'invoiceNo',
    label: 'Invoice No',
    minWidth: 100,
    render: (value, row) => (
      <Link to={`/inventory/invoices/view/${row.sourceId}`}>{value}</Link>
    ),
  },
  { id: 'supplierName', label: 'Supplier', minWidth: 120 },
  {
    id: 'totalAmount',
    label: 'Total Amount',
    minWidth: 100,
    align: 'right',
    format: (value) => (typeof value === 'number' ? value.toFixed(2) : value),
  },
  {
    id: 'totalDiscount',
    label: 'Discount',
    minWidth: 90,
    align: 'right',
    format: (value) => (typeof value === 'number' ? value.toFixed(2) : value),
  },
  {
    id: 'totalPayable',
    label: 'Payable',
    minWidth: 90,
    align: 'right',
    format: (value) => (typeof value === 'number' ? value.toFixed(2) : value),
  },
  {
    id: 'paidAmount',
    label: 'Paid Amount',
    minWidth: 90,
    align: 'right',
    format: (value) => (typeof value === 'number' ? value.toFixed(2) : value),
  },
  {
    id: 'balanceAmount',
    label: 'Balance Amount',
    minWidth: 100,
    align: 'right',
    format: (value) => (typeof value === 'number' ? value.toFixed(2) : value),
  },
  { id: 'paymentMethod', label: 'Payment Method', minWidth: 100, align: 'right' },
  { id: 'createdAt', label: 'Created At', minWidth: 120, align: 'right' },
];

const TableComp = memo(
  ({
    supplierInvoice: { isLoading, supplierInvoiceData },
    getSupplierInvoiceData,
    auth: { branchId },
  }) => {
    useEffect(() => {
      getSupplierInvoiceData();
    }, [branchId, getSupplierInvoiceData]);

    const rows = (supplierInvoiceData || []).map((row, index) => ({
      ...row,
      sourceId: row.id,
      id: row.incrementId ?? row.id ?? index,
    }));

    return (
      <div className={styles.tableWrap}>
        {isLoading && <Loading variant="overlay" label="" />}
        <Table
          columns={columns}
          rows={rows}
          disableInternalPagination={false}
          emptyMessage="No invoices found."
        />
      </div>
    );
  }
);

TableComp.propTypes = {
  getSupplierInvoiceData: PropTypes.func.isRequired,
  supplierInvoice: PropTypes.shape({
    isLoading: PropTypes.bool,
    supplierInvoiceData: PropTypes.array,
  }).isRequired,
  auth: PropTypes.shape({ branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }).isRequired,
};

const mapStateToProps = (state) => ({
  supplierInvoice: state.supplierInvoiceState,
  auth: state.authState,
});

export default connect(mapStateToProps, {
  getSupplierInvoiceData,
})(TableComp);
